import { render, staticRenderFns } from "./UserMessages.vue?vue&type=template&id=06a4f94e"
import script from "./UserMessages.vue?vue&type=script&lang=js"
export * from "./UserMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports